import { Component, OnInit } from '@angular/core';
import {ICellRendererParams} from 'ag-grid-community';
import {AgRendererComponent} from 'ag-grid-angular';
import { get } from 'lodash-es';
import { shouldShowChip } from '../shared/helpers/helpers';
import { IntegrationRef } from '../app.model';

@Component({
  selector: 'app-integration-name-render',
  templateUrl: './integration-name-render.component.html',
  styleUrls: ['./integration-name-render.component.scss']
})
export class IntegrationNameRenderComponent implements AgRendererComponent {

  public params: ICellRendererParams;
  userPlan: string;
  isDestination: boolean;
  isDestinationSet: boolean;

  agInit(params: ICellRendererParams): void {// console.log("name", params)
      this.params = params; // console.log(this.params, "IntegrationNameRenderComponent")
      this.isDestination = this.params['isDestination'];
      this.isDestinationSet = this.params.data['destinationName'] != null;
      this.userPlan = this.params.context.componentParent.userPlan;
  }

  public invokeParentMethod() {
      this.params.context.componentParent.methodFromParent(`Row: ${this.params.node.rowIndex}, Col: ${this.params.colDef.headerName}`);
  }

  refresh(): boolean {
      return false;
  }

  routeToDetails() {
    if (this.isDestinationSet) {
      const integration: IntegrationRef = {
        'integrationName': this.params.data.integrationName,
        'sourceId': this.params.data.sourceId,
        'status': this.params.data.status,
        'destinationName': this.params.data.destinationName
      };
      this.params.context.componentParent?.routeToDetails?.(integration);
    }
  }
  showChip(plan: string, userPlan: string) {
    return shouldShowChip(plan, userPlan);
  }

}
